import { createContext } from 'react';
import { ICellContext, IRowContext } from 'components/table-component/table-component.props';

export const RowContext = createContext<IRowContext>({ rowId: '' });

export const CellContext = createContext<ICellContext>({ cellId: '' });
